export default __webpack_public_path__ + "static/DEIPage-pattern-medium-yellow-13ff26c742f3263be6bd91ec8bcdab4e.png";